"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _axios = _interopRequireDefault(require("axios"));
var _PageContext = _interopRequireDefault(require("../../context/PageContext"));
var _UiContext = _interopRequireDefault(require("../../context/UiContext"));
var _fetchDataFromDOM = _interopRequireDefault(require("../../utils/fetchDataFromDOM"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const WebPageData = props => {
  const {
    children,
    noFetch = false
  } = props;
  const [pageData, setPageData] = (0, _react.useState)({});
  const setUi = (0, _react.useContext)(_UiContext.default)[1];
  const location = (0, _reactRouterDom.useLocation)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  (0, _react.useEffect)(() => {
    const fetchPageData = async () => {
      const {
        REACT_APP_PATH
      } = process.env;
      const pageDataUrl = "".concat(REACT_APP_PATH, "/Micado.Web.JSONEngine/Micado.Web.JSONEngine.IO.Api.PageApi/GetJSONData.api");
      const absoluteUrl = process.env.NODE_ENV === "production" ? window.location.href : REACT_APP_PATH + window.location.pathname;
      const headers = {};
      if (localStorage.getItem("logintoken")) {
        headers.Authorization = "Bearer ".concat(localStorage.getItem("logintoken"));
      }
      const response = await _axios.default.get(pageDataUrl, {
        headers,
        params: {
          absoluteUrl
        }
      });
      const {
        data,
        data: {
          darkSiteType,
          darkSiteURL,
          state,
          url
        }
      } = response || {};
      if (state === 301 || state === 302) {
        if (url) {
          window.location.href = url;
        } else {
          location.reload();
        }
        return;
      }

      /* DARKSITE ACTIVE */

      if (darkSiteType === "preview") {
        const {
          pathname
        } = location;
        const darksiteAlreadyRedirected = sessionStorage.getItem("mco-darksite-preview");
        if (darkSiteURL !== pathname && darksiteAlreadyRedirected === null) {
          navigate(darkSiteURL);
          sessionStorage.setItem("mco-darksite-preview", true);
        }
      }
      setPageData(data);
      setUi(prevUi => ({
        ...prevUi,
        _loading: false,
        _location: location
      }));
    };

    // fetch local data (from dom)

    if (!window.MCO_PAGE_LOADED && process.env.NODE_ENV === "production" && process.env.REACT_APP_FORCE_PAGEFETCH !== "true") {
      window.MCO_PAGE_LOADED = true;
      setPageData(_fetchDataFromDOM.default);
      setUi(prevUi => ({
        ...prevUi,
        _loading: false,
        _location: location
      }));
      return;
    }

    // set loading true

    setUi(prevUi => ({
      ...prevUi,
      _loading: true
    }));
    if (!noFetch) {
      fetchPageData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  return /*#__PURE__*/_react.default.createElement(_PageContext.default.Provider, {
    value: [pageData, setPageData]
  }, children);
};
var _default = exports.default = WebPageData;